import { Flex, Typography } from 'antd';
import { useLiveQuery } from 'dexie-react-hooks';
import { useTranslation } from 'translations/hooks';

import { DefectListDetail } from 'business/quality-control/pages/record-segment-defect/components/right-panel/defect-list-detail';
import { useBoardContext } from 'business/quality-control/pages/record-segment-defect/context/board-context';
import { ringSyncService } from 'technical/db/sync/ring-sync.service';

import { DefectDetail } from './defect-detail';
import { Header } from './header';
import styles from './index.module.scss';
import { RingBody } from './ring-body';

export const RingDetails = ({
  selectedRing,
  setSelectedRing,
}: {
  selectedRing: string;
  setSelectedRing: (ringId: string | null) => void;
}) => {
  const { t } = useTranslation();

  const { defectId } = useBoardContext();

  const ring = useLiveQuery(() => {
    return ringSyncService.getOneById(selectedRing);
  }, [selectedRing]);

  if (!ring) {
    return (
      <Flex vertical className={styles.content} justify="center">
        <Typography.Title level={4}>
          {t(
            'qualityControl.recordSegmentDefect.rightPanel.ringDetails.noSelection',
          )}
        </Typography.Title>
      </Flex>
    );
  }

  if (defectId) {
    return <DefectDetail defectReportId={defectId} ring={ring} />;
  }

  return (
    <>
      <Header
        title={t(
          'qualityControl.recordSegmentDefect.rightPanel.ringDetails.selectedRing',
          { ringNumber: ring.ringNumber },
        )}
        resetCurrentItem={() => setSelectedRing(null)}
      />

      <Flex vertical gap={16}>
        <RingBody ring={ring} />
        <DefectListDetail
          selectedRing={selectedRing}
          isRingCompliant={ring.compliantDate != null}
        />
      </Flex>
    </>
  );
};
